import React from 'react';
import './Main.css';

const propTypes = {
  children: React.PropTypes.object
}

const Main = props => (
  <main className='l-main'>
    {props.children}
  </main>
)

Main.propTypes = propTypes;

export default Main;



// WEBPACK FOOTER //
// ./src/layout/Main/Main.js